function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.067.307l4.409 4.412-4.409 4.412L.66 4.72 5.067.307z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.5
});

var SvgBendSquare = function SvgBendSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMDY3MiAwLjMwNjY0MUw5LjQ3NTc1IDQuNzE4OTlMNS4wNjcyIDkuMTMxMzNMMC42NTg2NDYgNC43MTg5OUw1LjA2NzIgMC4zMDY2NDFaIiBzdHlsZT0iZmlsbDojMDAwMDAwO3N0cm9rZTojMDAwMDAwO3N0cm9rZS13aWR0aDowLjUiLz4KPC9zdmc+Cg==";
export { SvgBendSquare as ReactComponent };